// extracted by mini-css-extract-plugin
export default {"box":"SendWebhook_box__R2+f4","selectTitle":"SendWebhook_selectTitle__sDuNj","title":"SendWebhook_title__cP+U6","inputTitle":"SendWebhook_inputTitle__NTsFV"};